import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { formatString } from '../../utils/common';

const useStyles = makeStyles({ name: 'EmobilityPreviewStep' })(theme => ({
	root: {
		display: 'flex',
		gap: 20,
		color: theme.palette.text.primary
	},
	index: {
		flexShrink: 0,
		width: 26,
		height: 26,
		borderRadius: '13px',
		border: '1.7px solid ' + theme.palette.primary.main,
		color: theme.palette.primary.main,
		fontWeight: theme.typography.fontWeightBold,
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	stepContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		gap: 20
	},
	title: {
		minHeight: 26,
		fontSize: '18px',
		lineHeight: '24px'
	},
	text: {
		fontSize: '16px',
		lineHeight: '24px',
		'& b': {
			fontSize: '18px',
			lineHeight: '24px'
		}
	}
}));

export type EmobilityPreviewStepProps = {
	index: number;
	title: string;
	text: string;
	params: string[];
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};

export const EmobilityPreviewStep: React.FC<EmobilityPreviewStepProps> = (props) => {
	const { index, title, text, params } = props;
	const { classes: styles } = useStyles(undefined, { props });

	return (
		<div className={styles.root} data-test='emobility-preview-step'>
			<div className={styles.index} data-test='number'>
				{index}
			</div>
			<div className={styles.stepContent} data-test='content'>
				<div className={styles.title} data-test='tile'>{title}</div>
				<div className={styles.text} data-test='example-text'
					dangerouslySetInnerHTML={{ __html: formatString(text, ...params.map(param => '<b>' + param + '</b>')) }} />
			</div>
		</div>
	);
};